// styles
import 'bootstrap/dist/css/bootstrap.min.css';
import "./App.css";

import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import ReactGA from 'react-ga';

import Home from "./pages/Home";
import AddVendor from "./utils/AddVendor";
import AddPromo from "./utils/AddPromo";
import DeletePromo from "./utils/DeletePromo";
import SinglePromoCode from "./pages/SinglePromoCode";



function App() {
  
const TRACKING_ID = "UA-120935334-3"; // YOUR_OWN_TRACKING_ID
ReactGA.initialize(TRACKING_ID);
ReactGA.event({
  category: window.location.hostname,
  action: 'Visited Hompage',
  label: 'homepage'
});


  return (
    <>
      <Router>
      <Switch>

      <Route exact
          path="/"
          component={Home}
        />

        <Route exact
          path="/AddVendor"
          component={AddVendor}
        />
     
        <Route exact
          path="/AddPromo"
          component={AddPromo}
        />
     
        <Route exact
          path="/DeletePromo"
          component={DeletePromo}
        />
     

     <Route exact
        path="/details/:vendor" 
        component={SinglePromoCode}
         />

      
      </Switch>
      </Router>
    </>
  );
}

export default App;
